import { Helmet } from "react-helmet-async";

const LoadFonts = () => (
  <Helmet>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Spartan:wght@700&display=swap"
      rel="stylesheet"
    />
  </Helmet>
);

export default LoadFonts;
